type RequireContext = {
    keys: () => string[];
    (id: string): { default: string };
};

export const importAllImages = (imageContexts: RequireContext) => {
    const imagesDir: { [key: string]: string } = {};
    imageContexts.keys().forEach((item: string) => {
        imagesDir[item.replace('./', '')] = imageContexts(item).default;
    });
    return imagesDir;
};
